import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { HR_NAV_TABS, getHRTabHref, getActiveHRTabId } from '../../utils/hrTabs';

/**
 * Index redirect for /portal/hr. Sidebar search deep links use
 * /portal/hr?material=<title>, which now lives on the Materials tab, so the
 * query string decides the destination and is preserved.
 */
export const HRIndexRedirect = () => {
  const location = useLocation();
  const target = new URLSearchParams(location.search).has('material') ? 'materials' : 'all';
  return <Navigate to={{ pathname: target, search: location.search }} replace />;
};

const HRTabNav = () => {
  const location = useLocation();
  const activeTabId = getActiveHRTabId(location.pathname);

  return (
    <nav className="flex flex-wrap justify-center gap-2 mb-6 px-2" aria-label="HR sections">
      {HR_NAV_TABS.map((tab) => {
        const isActive = activeTabId === tab.id;
        return (
          <Link
            key={tab.id}
            to={getHRTabHref(tab)}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
              isActive
                ? 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 ring-1 ring-red-200 dark:ring-red-800'
                : 'bg-gray-50 dark:bg-gray-700/50 text-gray-700 dark:text-gray-200 hover:bg-red-50 dark:hover:bg-red-900/20'
            }`}
          >
            {tab.emoji && (
              <span className="text-base leading-none shrink-0" aria-hidden="true">{tab.emoji}</span>
            )}
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default HRTabNav;
